module.exports = __webpack_public_path__ + "static/media/custom-ex-5.1d28006d.jpg";